import appServices from '@/services/appServices';
import { AIRuleResponse } from '@polybank/shared/types/ai-contracts';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

export function useMatchingTransactionsCount(rawRule?: AIRuleResponse) {
  const transactionsQuery = useQuery({
    queryKey: ['matching-transactions-count', rawRule],
    queryFn: () => {
      return appServices.rulesApi.countMatchingTransactions(
        rawRule!.conditions
      );
    },
    enabled: !!rawRule,
  });

  const count = useMemo(() => {
    return transactionsQuery.data?.count ?? 0;
  }, [transactionsQuery.data]);

  const transactions = useMemo(() => {
    return transactionsQuery.data?.transactions ?? [];
  }, [transactionsQuery.data]);
  return {
    count,
    transactions,
    isLoading: transactionsQuery.isLoading,
    isError: transactionsQuery.isError,
    error: transactionsQuery.error,
  };
}
